import React, { useEffect, useRef } from "react";
import Odometer from "odometer";
import "odometer/themes/odometer-theme-default.css";
import styles from "./index.module.scss";

interface OdometerCounterProps {
  value: number;
  className?: string;
  format?: string;
  theme?: string;
}

const OdometerCounter: React.FC<OdometerCounterProps> = ({
  value,
  className = "",
  format = "(,ddd)",
  theme = "default",
}) => {
  const odometerRef = useRef<HTMLDivElement>(null);
  const odometerInstance = useRef<any>(null);

  useEffect(() => {
    if (odometerRef.current && !odometerInstance.current) {
      // 初始化 Odometer
      odometerInstance.current = new Odometer({
        el: odometerRef.current,
        value: value,
        format: format,
        theme: theme,
        animation: "slide", // 滑动动画
      });
    }

    return () => {
      // 清理函数 - odometer 没有 destroy 方法，所以只需要清理引用
      if (odometerInstance.current) {
        odometerInstance.current = null;
      }
    };
  }, [format, theme, value]);

  useEffect(() => {
    if (odometerInstance.current) {
      odometerInstance.current.update(value);
    }
  }, [value]);

  return (
    <div
      ref={odometerRef}
      className={`odometer ${styles.odometerCustom} ${className}`}
    />
  );
};

export default OdometerCounter;
